import revive_payload_client_4sVQNw7RlN from "/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/src/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/src/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/src/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/src/.nuxt/sentry-client-config.mjs";
import plugin_iGLjBbor9q from "/src/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import plugin_I4dbrL2rYz from "/src/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.js";
import plugin_hwlJ5PmHMh from "/src/node_modules/nuxt-lazy-load/dist/runtime/plugin.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import directives_GDwrTGmylM from "/src/plugins/directives.js";
import locale_client_nqGmhPruNH from "/src/plugins/locale.client.js";
import vue3_flickity_XqNjU0qzlc from "/src/plugins/vue3-flickity.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  plugin_iGLjBbor9q,
  plugin_I4dbrL2rYz,
  plugin_hwlJ5PmHMh,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  directives_GDwrTGmylM,
  locale_client_nqGmhPruNH,
  vue3_flickity_XqNjU0qzlc
]